import { AutomationEventTypes } from '@tokeet-frontend/automations'

export const userMessageNotificationMessages = {
  [`${AutomationEventTypes.GuestMessageCreated}`]: {
    subject: 'New Guest Message received',
    message: `
      Hi Team,

      A new message has been received from guest *|GUEST:NAME|*. Please review and respond as necessary.
      `,
  },
}
